import React from 'react'
import Reflux from 'reflux'
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button
} from 'reactstrap'

import IngredientsStore from '~/stores/ingredients'
import IngredientsActions from '~/actions/ingredients.js'
import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'
import IngredientsList from '~/modules/modals/ingredients/list.jsx'
import IngredientsAdd from '~/modules/modals/ingredients/add.jsx'


export default class RecipeIngredientsModal extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = IngredientsStore
	}

	render() {
		return (
			<OnlyIfAuthorized>
				<Modal
					size="lg"
					isOpen={this.state.showIngredientsModal === true}
				>
					<ModalHeader
						toggle={IngredientsActions.hideModal}
					>
						Recipe Ingredients
					</ModalHeader>
					<ModalBody>
						<IngredientsAdd
							ingredientID={0}
						/>

						<IngredientsList />
					</ModalBody>
					<ModalFooter>
						<Button
							onClick={IngredientsActions.hideModal}
						>
							Close Ingredients
						</Button>
					</ModalFooter>
				</Modal>
			</OnlyIfAuthorized>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredients.jsx